import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { GUIDES } from "../../../data/sitePages";
import { photoFromPool } from "../../../data/themePhotos";
import { track } from "../../../lib/analytics";

export const FeaturedGuides = () => (
  <section data-testid="featured-guides" className="mx-auto max-w-[1400px] px-6 py-24 md:px-10 md:py-28">
    <div className="mb-10 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="overline text-brand-inkSoft">Section 05</p>
        <h2 className="mt-3 font-display text-3xl leading-tight text-brand-ink md:text-5xl">Featured guides</h2>
      </div>
      <Link to="/guides" data-testid="view-all-guides" className="text-sm font-medium text-brand-ink link-underline">View all guides</Link>
    </div>
    <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
      {GUIDES.map((g, i) => (
        <Link key={g.slug} to={`/guides/${g.slug}`} onClick={() => track("guide_card_clicked", { slug: g.slug, title: g.title })} data-testid={`guide-card-${g.slug}`} className="group block fade-up" style={{ animationDelay: `${i * 60}ms` }}>
          <div className="card-img-wrap img-gradient-overlay relative aspect-[3/4] w-full bg-brand-bg2">
            <img src={photoFromPool(g.theme, i + 2)} alt={g.title} loading="lazy" className="card-img absolute inset-0 h-full w-full object-cover" />
            <span className="absolute left-4 top-4 z-10 rounded-full bg-white/90 px-3 py-1 text-[11px] font-medium text-brand-ink">Guide</span>
          </div>
          <h3 className="mt-4 flex items-start justify-between gap-2 px-1 font-display text-lg leading-snug text-brand-ink">
            {g.title}
            <ArrowUpRight size={16} className="mt-1 shrink-0 text-brand-terracotta transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </h3>
        </Link>
      ))}
    </div>
  </section>
);

export default FeaturedGuides;
